export const STAGE_LABELS = {
  encontrado: "Encontrado",
  analisado: "Analisado",
  demo_pronta: "Demonstração pronta",
  aguarda_aprovacao: "À espera da minha aprovação",
  enviado: "Enviado",
  respondeu: "Respondeu",
  reuniao: "Reunião",
  cliente: "Cliente GestaCV",
  descartado: "Descartado",
};
export const STAGES = Object.keys(STAGE_LABELS);
export const SITE_CLASS = { sem_site: "Sem site", so_redes: "Só redes sociais", tem_site: "Tem site" };
export const SECTORS = ["restaurantes", "alojamentos", "salões", "oficinas", "clínicas"];
export const AGENT_LABELS = { analista: "Analista", designer: "Designer", prospector: "Prospector" };
export const NEXT_AGENT = { encontrado: "analista", analisado: "designer", demo_pronta: "prospector" };
